var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-gray-300 antialiased flex flex-col"},[_c('AdminNavbar',{staticClass:"fixed w-full z-20"}),_c('router-view',{staticClass:"mt-24"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }